import idConfig from 'utils/ecommerce/services/id.config';
import { getLanguage } from 'utils/language/language';
import hasObjectPath from 'utils/objectsValidation/hasObjectPath';
import { env as E } from 'config/app.config';

interface functionalEndpointConfig extends types.endpoints.functionalEndpointConfig {}

const eCommerceParams = () => {
	const language = (idConfig.LANGUAGE as any)[getLanguage().toUpperCase()];
	return `?langId=${language}&catalogId=10102&searchType=1000&currency=OMR&responseFormat=json&searchSource=E&pageSize=999&pageNumber=1`;
};

const _getByCategory = (category: string): string => {
	return `productview/byCategory/${category}${eCommerceParams()}`;
};

const _getByID = (id: string): string => {
	return `productview/byId/${id}${eCommerceParams()}`;
};

const _getBySearchTerm = (searchTerm: string): string => {
	return `productview/bySearchTerm/${searchTerm}${eCommerceParams()}`;
};

const _asEndpoint = (url: string): types.endpoints.IEndpointConfig => {
	return {
		url: url,
	};
};

export const getGroupContent: functionalEndpointConfig = (groupID: string) => {
	return _asEndpoint(_getByCategory(groupID));
};

export const getContentByUniqueID: functionalEndpointConfig = (uniqueID: string) => {
	return _asEndpoint(_getByID(uniqueID));
};

export const getContentBySearchTerm: functionalEndpointConfig = (searchTerm: string) => {
	return _asEndpoint(_getBySearchTerm(searchTerm));
};

export const getContentByPartNumber: functionalEndpointConfig = (partNumber: string) => {
	return _asEndpoint(`productview/${partNumber}${eCommerceParams()}`);
};

export const getByGroupAndType: any = (group: types.ecommerce.PackageGroup, type: types.ecommerce.PackageType) => {
	// @ts-ignore
	if (hasObjectPath(idConfig.PACKAGES, group, type)) {
		const categoryID = (idConfig.PACKAGES as any)[group][type][E];
		return _asEndpoint(_getByCategory(categoryID));
	} else {
		return _asEndpoint('');
	}
};
